export default function isEnumOfType<T extends object>(enumValue: T) {
  return (enumTypeValue: unknown): enumTypeValue is T[keyof T] => Object.values(enumValue).includes(enumTypeValue as T[keyof T]);
}
